import script from "./ClusterGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClusterGrid.vue?vue&type=script&setup=true&lang=ts"

import "./ClusterGrid.vue?vue&type=style&index=0&id=f241b174&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f241b174"]])

export default __exports__